module.exports = __webpack_public_path__ + "img/icon_5_98.86380174.png";